import { apiClient } from "./apiClient";
import { endpoints } from "./endpoints";
import type { ApiRecord } from "@/types/api";

/** Wraps `GET /api/v1/market-data/providers` - zero-argument, real provider-availability data for the Market Status section. */
export const marketDataService = {
  async getProviderStatus(): Promise<ApiRecord> {
    const response = await apiClient.get<ApiRecord>(endpoints.marketData.providers);
    return response.data;
  },
};
